import { useRef, useState } from 'react'
import { LoginAsync, OTPCompleted, SelectErrorMessage, SelectIsLoading, SelectIsReadyForOTP, selectLoginModalShow, setErrorMessage, setIsReadyForOTP, setLoginModalShow } from '../features/authentication/authenticationSlice'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { Box, Button, Modal, Stack, TextField } from '@mui/material'
import { loginModalStyle, MyCustomTokenPayload } from '../app/consts'
import emailjs from '@emailjs/browser'
import { toast } from 'react-toastify'
import { jwtDecode } from 'jwt-decode'

const Authentication = () => {
  const dispatch = useAppDispatch();
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')

  const loginModalShow = useAppSelector(selectLoginModalShow);
  const isLoading = useAppSelector(SelectIsLoading);
  const errorMsg = useAppSelector(SelectErrorMessage);

  emailjs.init("y7dwm07pNohWq81rU");

  const inputRefs = useRef<any[]>([]);
  const codeRef = useRef<number>(0);
  const reSendSeconds = useRef<number>(0);
  const [displaySeconds, setDisplaySeconds] = useState(45);
  const [userInput, setUserInput] = useState<string[]>(new Array(6).fill([]));
  const [resendAvail, setResendAvail] = useState(false)
  const IsReadyForOTP = useAppSelector(SelectIsReadyForOTP);

  const handleChange = (e: any, index: number) => {
    const value = e.target.value;
    if (isNaN(value)) return; // Only allow numeric input

    const temp = [...userInput];
    temp[index] = value.slice(-1); // Take only the last character entered
    setUserInput(temp);

    // Move focus to the next input if a digit is entered
    if (value && index < 6 - 1) {
      inputRefs.current[index + 1].focus();
      inputRefs.current[index + 1].select();
    }
  };

  const handleKeyDown = (e: any, index: number) => {
    if (e.key === 'Backspace' && !userInput[index] && index > 0) {
      // Move focus to the previous input on backspace if current is empty
      inputRefs.current[index - 1].focus();
      inputRefs.current[index - 1].select();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault(); // stop default paste into one field
    const paste = e.clipboardData.getData('text').trim();

    if (!/^\d+$/.test(paste)) return;

    const digits = paste.slice(0, 6).split('');
    const newOtp = Array(6).fill('');
    digits.forEach((digit, i) => {
      newOtp[i] = digit;
    });
    setUserInput(newOtp);

    // move focus to the last filled box
    const lastIndex = Math.min(digits.length, 6) - 1;
    inputRefs.current[lastIndex]?.focus();
    inputRefs.current[lastIndex]?.select();
  };

  const fetchUserData = ():MyCustomTokenPayload => {
    const token = sessionStorage.getItem('loginToken')
    if (token === null) {
      return {'mfa':true,'name':"",'user_id':-1,"email":"",'isSU':false}
    }
    const decodedToken = jwtDecode<MyCustomTokenPayload>(token)
    return decodedToken
  }

  const sendOTPMessage = async(user: MyCustomTokenPayload) => {
    const code = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
    codeRef.current = code;

    await emailjs.send("service_1qd2ez8", "template_64ap4yc", {
      subject: "קוד אימות חד פעמי",
      email: user.email,
      msg: `
שלום ${user.name},
נא להזין את הקוד הבא במערכת:
${codeRef.current?.toString()}
אם לא ניסית לבצע התחברות כעת, יש ליצור קשר בהקדם עם מנהל המערכת`,
      isRegister: false //registration links wil be hidden
    }).then(()=>{console.log("mail sent")}).catch(()=>{console.error("Failed to send mail")});

  }

  const handleSubmit = () => {
    if (userName !== '' && password !== '') {
      dispatch(LoginAsync({ username: userName, password: password })).unwrap()
        .then(() => {
          const user = fetchUserData()
          if(user.mfa === false){
            toast.success('התחברות בוצעה בהצלחה');
            dispatch(OTPCompleted())
            return;
          }
          if (user?.email?.length === 0 || user?.email === undefined) {
            dispatch(setErrorMessage("חלה שגיאה"))
            return;
          }
          sendOTPMessage(user);
          dispatch(setIsReadyForOTP(true))

          const dest = new Date().getTime() + 45000;
          const inter = setInterval(() => {
            const now = new Date().getTime();
            var distance = dest - now;

            reSendSeconds.current = (Math.floor((distance % (1000 * 60)) / 1000));
            setDisplaySeconds(reSendSeconds.current)

            if (distance <= 0) {
              clearInterval(inter);
              setResendAvail(true);
            }
          }, 1000);
        })
        .catch((error) => {
          console.error(error)
          dispatch(setErrorMessage("שם משתמש / סיסמא שגויים"))
        })
    }
    else {
      dispatch(setErrorMessage("קיים חוסר בפרטים"))
    }
  }

  const handleDone = () => {
    const userCodeInput = userInput.join("")
    if (codeRef.current?.toString() === userCodeInput) {
      setIsReadyForOTP(false);
      toast.success('התחברות בוצעה בהצלחה');
      dispatch(OTPCompleted())
      setUserInput(new Array(6).fill([]))
      inputRefs.current = []
    }
    else {
      toast.error("הקוד לא תואם, נסה שנית");
    }
  }


  return (
    <Modal
      open={loginModalShow}
      onClose={() => {
        dispatch(setLoginModalShow(false));
        dispatch(setIsReadyForOTP(false));
      }}>
      <Box sx={loginModalStyle}>
        <p style={{ fontSize: '20px', fontWeight: 'bold' }} onClick={() => { dispatch(setLoginModalShow(false)); dispatch(setIsReadyForOTP(false)); }}>X</p>
        {isLoading ?
          <img src='/FadingCircles.gif' alt='spinner' />
          :
          <>
            {IsReadyForOTP ?
              <div>
                קוד חד פעמי נשלח לכתובת הדואר האלקטרוני שהזנת במעמד ההרשמה.<br />
                אנא הזן את הקוד ולחץ על הכפתור המשך<br /><br /><br /><br />
                <Stack direction="row-reverse" sx={{ justifyContent: "center", alignItems: "center", }}>
                  {userInput.map((digit, index) => (
                    <TextField
                      key={index}
                      inputRef={(el) => (inputRefs.current[index] = el)}
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      slotProps={{
                        htmlInput:{
                        maxLength: 1,
                        style: { textAlign: 'center' },
                        inputMode: 'numeric', // Show numeric keyboard on mobile
                        autoComplete: 'one-time-code', // Suggest OTP on iOS
                        }
                      }}
                      variant="standard"
                      sx={{ marginLeft: 2 }}
                    />
                  ))}
                </Stack><br /><br /><br />
                {resendAvail ? <Button onClick={() => {
                  const user = fetchUserData();
                  sendOTPMessage(user)
                }}>שלח קוד חדש</Button> : <p>אנא המתינו {displaySeconds} לשליחת קוד חדש</p>}
                <br />
                <Button id='submit' type='submit' onClick={() => handleDone()} variant="contained" size='large' color='info'>המשך</Button>
              </div>
              :
              <>
                <form method='POST' id='login_form' style={{ textAlign: 'center', fontSize: '30px' }} onSubmit={(e) => e.preventDefault()}>
                  <p>אנא התחבר</p>
                  <TextField variant="filled" label='שם משתמש' type='text' name='username' placeholder='שם משתמש' onChange={(e) => setUserName(e.currentTarget.value)} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} />
                  <br /><br />
                  <TextField variant="filled" label='סיסמא' type='password' name='pass' placeholder='סיסמא' onChange={(e) => setPassword(e.currentTarget.value)} required style={{ fontSize: '20px', width: '80%', textAlign: 'center' }} />
                  <br /><br />
                  <Button
                    type='submit'
                    onClick={handleSubmit}
                    variant="contained"
                    size='large' color='info'>התחבר</Button>
                  <p>{errorMsg}</p>
                </form>
              </>}
          </>
        }
      </Box>
    </Modal>
  )
}

export default Authentication